<template>
  <div
    class="flex flex-col min-h-screen overflow-auto text-gray-700 bg-gray-100 dark:text-gray-200 dark:bg-gray-900 transition-colors duration-200"
  >
    <div
      v-if="!$store.getters.isAuthInitialized"
      class="flex items-center justify-center min-h-screen"
    >
      Loading...
    </div>
    <template v-else>
      <the-header :is-auth="!!user" />
      <main class="flex-grow">
        <router-view :key="$route.fullPath" />
      </main>
      <the-footer />
    </template>
  </div>
</template>

<script>
import TheHeader from "@/components/TheHeader.vue";
import TheFooter from "@/components/TheFooter.vue";
import { firebaseAuth, firestore } from "@/services/firebase";
import { onAuthStateChanged } from "firebase/auth";
import { doc, setDoc } from "firebase/firestore";

export default {
  components: { TheHeader, TheFooter },
  data() {
    return {
      user: null,
    };
  },
  watch: {
    "$store.state.darkMode": {
      handler(isDarkMode) {
        document.documentElement.classList.toggle("dark", isDarkMode);
      },
      immediate: true,
    },
  },
  created() {
    onAuthStateChanged(firebaseAuth, (user) => {
      this.user = user;

      if (user) {
        const userDTO = {
          ...user.providerData[0],
          emailVerified: user.emailVerified,
          isAnonymous: user.isAnonymous,
          uid: user.uid,
          lastSignInTime: user.metadata.lastSignInTime,
        };

        setDoc(doc(firestore, "users", user.uid), userDTO, { merge: true });
        this.$store.commit("setUser", userDTO);
      } else {
        this.$store.commit("setUser", null);
      }

      // Mark auth as initialized after first check
      this.$store.dispatch("initializeAuth");
    });
  },
};
</script>
